module.exports = __webpack_public_path__ + "static/media/news5.14ba0002.jpeg";